RivalIQ.apps.LandscapeSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.RenamingModal = Marionette.ItemView.extend({
        ui: {
            rename: '.x-rename-landscape',
            modal: '.modal',
            name: 'input[name="name"]',
            nameFormGroup: '.form-group.x-name'
        },
        events: {
            'click @ui.rename': 'onRenameClicked',
            'keypress @ui.name': 'onKeypressed'
        },
        template: '#landscapeSettingsRenamingModalTemplate',
        onRender: function () {
            const me = this;

            me.ui.modal.on('shown.bs.modal', function () {
                me.ui.name.select();
            });

            me.ui.modal.modal();
        },
        onRenameClicked: function () {
            const me = this;
            const model = me.model;
            const name = $.trim(me.ui.name.val());

            me.ui.nameFormGroup.removeClass('has-error');
            me.ui.nameFormGroup.find('.help-block').hide();

            const MAX_NAME_LENGTH = 100;
            if (!name || name.length > MAX_NAME_LENGTH) {
                me.ui.nameFormGroup.addClass('has-error');
                me.ui.nameFormGroup.find('.help-block').show();
                return;
            }

            // if the rename button is disabled, or the name has not changed do nothing
            if (name === model.get('landscapeName')) {
                me.ui.modal.modal('hide');
                return;
            }

            // Update array for redrawing dropdown
            _.find(RivalIQ.state.user.attributes.landscapes, {
                id: model.get('landscapeId')
            }).name = name;

            model.set({
                landscapeName: name
            });

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.RenamedLandscape);

            me.ui.modal.modal('hide');
        },
        onKeypressed: function (e) {
            const me = this;

            if (e.keyCode === 13) {

                e.preventDefault();
                me.onRenameClicked();
            }
        }
    });
});
